import React, {FC, useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useScriptInjector} from '@/common/services/headTagger';
import {selectNoAds} from '@/app/store/config/selectors';
import {DfpAdContext, DfpAdContextValue} from './DfpAdContext';
import {useDfpTargeting} from './useDfpTargeting';

if (typeof window !== 'undefined') {
	const googletagGlobal = (window as any).googletag || {};
	googletagGlobal.cmd ||= [];
	(window as any).googletag = googletagGlobal;
}

const DfpAdProviderInner: FC = props => {
	const {children} = props;

	const [serviceEnabled, setServiceEnabled] = useState(false);

	useDfpTargeting();

	const value = useMemo<DfpAdContextValue>(
		() => ({
			serviceEnabled,
		}),
		[serviceEnabled],
	);

	// Enable services after all banner below defined
	useEffect(() => {
		googletag.cmd.push(() => {
			googletag.setConfig({
				singleRequest: true,
				safeFrame: {
					forceSafeFrame: true,
					allowOverlayExpansion: true,
					allowPushExpansion: true,
				},
				collapseDiv: 'BEFORE_FETCH',
				centering: true,
			});
			googletag.enableServices();
			setServiceEnabled(true);
		});
	}, []);

	// Inject the Google Publisher Tag script
	useScriptInjector({
		src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
		async: true,
	});

	return <DfpAdContext.Provider value={value}>{children}</DfpAdContext.Provider>;
};

DfpAdProviderInner.displayName = 'DfpAdProviderInner';

export const DfpAdProvider: FC = props => {
	const {children} = props;

	const noAds = useSelector(selectNoAds);
	const noAdsValue = useMemo(() => ({serviceEnabled: false}), []);

	if (noAds) {
		return <DfpAdContext.Provider value={noAdsValue}>{children}</DfpAdContext.Provider>;
	}

	return <DfpAdProviderInner {...props} />;
};

DfpAdProvider.displayName = 'DfpAdProvider';
